export default "__VITE_ASSET__WWNZR6TD__"